import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const Problems: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section id="why-us" className="py-24 bg-white" ref={ref}>
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Text Content */}
          <div className={`space-y-8 reveal-left ${isVisible ? 'active' : ''}`}>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold font-bricolage mb-6">
                Why Choose <span className="text-highlight">Singh's Best Buy</span>
              </h2>
              <div className="w-20 h-1 bg-primary-500 rounded-full"></div>
            </div>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                At Singh's Best Buy, we believe that real estate is not just about buying property — it's about building long-term relationships grounded in trust, clarity, and shared growth.
              </p>
              <p>
                Our goal isn't simply to sell you a project; our mission is to guide you toward the right decision — one that aligns with your family's lifestyle, your future plans, and your investment vision.
              </p>
              <p>
                We're a research-driven, data-backed real estate aggregator that ensures your capital is invested in projects with genuine growth potential. <span className="font-semibold text-primary-600">We also specialize in large land parcels across North India, especially Uttrakhand</span>, offering unique opportunities for substantial investments.
              </p>


            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { title: "HNI & CEO Clientele", icon: "https://cdn.prod.website-files.com/6778043699a2f913f47628dd/6778d377fd88f099cb254090_02-problems-icon.svg", desc: "Trusted by industry leaders for high-value investments." },
              { title: "Selective Luxury", icon: "https://cdn.prod.website-files.com/6778043699a2f913f47628dd/6778d377323c341c6bfb0be3_01-problems-icon.svg", desc: "Handpicked developments with proven appreciation potential." },
              { title: "Research-Driven", icon: "https://cdn.prod.website-files.com/6778043699a2f913f47628dd/6778d37769cc7a0553154989_04-problems-icon.svg", desc: "Decisions backed by data, strategy, and market analysis." },
              { title: "Exclusive Access", icon: "https://cdn.prod.website-files.com/6778043699a2f913f47628dd/6778d377ed0c7c25926a81ee_03-problems-icon.svg", desc: "Unlock pre-launch pricing and strategic options." }
            ].map((item, index) => (
              <div
                key={index}
                className={`bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-all duration-300 reveal-right stagger-delay-${index + 1} ${isVisible ? 'active' : ''}`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-white rounded-xl shadow-sm flex items-center justify-center mb-6 p-3">
                  <img src={item.icon} alt={item.title} className="w-full h-full object-contain" />
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  )
}

export default Problems
